import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

const DEFAULT_SIZE = 20;

function createInteractor(repository: Repository): Interactor {
  return ({ subject, type, page = 0, size = DEFAULT_SIZE }) =>
    present(
      repository
        .getDiscussion(subject, type, page, size)
        .then((discussion) => ({ subject, type, discussion, page, size }))
        .catch(() => Promise.reject({ subject, type })),
    );
}

export type { Interactor };

export { createInteractor };
